import * as setup from 'setup';
import Ant from '../Ant/Ant';
import Nature from '../Nature/Nature';
import Danger from './Danger';
import DangerAntWarrior from './DangerAntWarrior';
import DangerAntWorker from './DangerAntWorker';

export default class DangerSpider extends Danger {
    target: Ant | DangerAntWarrior | DangerAntWorker | null;
    web: Nature;

    textureRotation = Math.PI;

    constructor(gameState: GameState, props?: DangerProps, state?: any) {
        super(gameState, 'spider', setup.dangers.spider, props, state);

        // Initialize
        this.web = gameState.entities.natures.active.find(nature => nature.type === 'web') as Nature;
        this.placeAt(this.web.cell);
        this.visible = false;
    }

    init = () => {
        this.playSound('danger-spider-walk', 1, true);
        this.sound?.pause();
        this.findTarget();
    };

    findTarget = () => {
        // Get closest Ant
        const targets = [
            ...this.gameState.entities.ants.explorers.active,
            ...this.gameState.entities.ants.warriors.active,
            ...this.gameState.entities.ants.workers.active,
            ...this.gameState.entities.dangers.antWarriors.active,
            ...this.gameState.entities.dangers.antWorkers.active,
        ];
        this.target = this.getClosestTarget(targets, this.setup.searchDistance);

        // If close enough, attack, otherwise move again
        if (this.isCloseToTarget(this.target)) {
            this.reveal();
            this.attackTarget(this.target, this.findTarget);
            this.playSound('danger-spider-shoot');
        } else if (
            this.target &&
            (!this.setup.searchDistance || this.target.getDistanceTo(this.web.cell) <= this.setup.searchDistance)
        ) {
            this.reveal();
            this.moveToTarget(this.target, this.findTarget);
            this.resumeSound();
        } else if (this.cellName !== this.web.cellName) {
            this.moveTo(this.web.cell, 0, this.wait);
            this.resumeSound();
        } else {
            this.wait();
        }
    };

    reveal = () => {
        if (!this.visible) {
            this.visible = true;
            this.gameState.revealFog(this.cell, this.size);
        }
    };

    wait = () => {
        this.pauseSound();
        this.queue(this.findTarget, true);
    };
}
